import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class SpatialContextService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/spatial-context');
  }

  public getOptions(): Promise<any> {
    return axios.get(this.endpointName + '/combobox');
  }
}
